.s-user-settings{
  &-wrapper{

  }
  &-section{

  }
  &-title{

  }
  &-subtitle{

  }
  &-action{
    
  }
}